import create from "zustand";
import produce from "immer";

const useCurrentSettingStore = create((set) => ({
	taxDefaults: {},
	profitSettings: {
		// defaults and expected values
		// isDocFeeProfit: 2,
		// isAftMktProfit: 1,
		// isServConProfit: 2,
		// isGapProfit: 2,
		// isMiscProfit: 1,
		// isBankFeeProfit: 1,
		// isReserveProfit: 0,
		// isDealerSmogProfit: 1,
	},
	commissionSettings: {},

	editTaxDefaults: (e) => set(() => ({ taxDefaults: e })),

	editProfitSettings: (e) => set(() => ({ profitSettings: e })),

	editCommissionSettings: (e) => set(() => ({ commissionSettings: e })),

	editTaxDefaultsValue: (key, val) =>
		set(
			produce((state) => {
				state.taxDefaults = {
					...state.taxDefaults,
					[key]: val,
				};
			})
		),

	editProfitSettingsValue: (key, val) =>
		set(
			produce((state) => {
				state.profitSettings = {
					...state.profitSettings,
					[key]: val,
				};
			})
		),

	editCommissionSettingsValue: (key, val) =>
		set(
			produce((state) => {
				state.commissionSettings = {
					...state.commissionSettings,
					[key]: val,
				};
			})
		),

	setSettingFields: (res) =>
		set((state) => ({
			...res,
		})),

	reset: () =>
		set({
			taxDefaults: {},
			profitSettings: {
				// defaults and expected values
				// isDocFeeProfit: 2,
				// isAftMktProfit: 1,
				// isServConProfit: 2,
				// isGapProfit: 2,
				// isMiscProfit: 1,
				// isBankFeeProfit: 1,
				// isReserveProfit: 0,
				// isDealerSmogProfit: 1,
			},
			commissionSettings: {},
		}),
}));

export default useCurrentSettingStore;
